<template>
  <ul
    :class="[{ 'm-edition-asset-contents-list-child': isChild }, 'm-edition-asset-contents-list']"
  >
    <li
      :class="[{ 'm-edition-asset-contents-list-item-drag': !disabledDragg }, 'm-edition-asset-contents-list-item']"

    >
      <div class="m-edition-asset-contents-list-item-data">
        <a
          class="fc-event m-edition-asset-contents-list-item-data-name"
          href="#"
          ref="el"
          @click.prevent="toggleChildren"
        >
          <i :class="showChildren && nodo.children.length ? 'fas fa-caret-down' : 'fas fa-caret-right'"></i>
          <span>{{ nodo.nombre }}
            <small v-if="nodo.children.length">
              ({{ nodo.children.length }} {{ $t('mEditionAssetContentsTreeNodes.subcontents') }})
            </small>
          </span>
        </a>
        <div :class="`m-edition-asset-contents-list-item-data-actions-${nodeActionsClass}`" >
          <MoleculeEditionAssetContentsTreeNodeActions
            :is="moleculeNodeActions"
            :contenido="contenido"
            :element="element"
            :info="info"
            :nodo="nodo"
            :parent="parent"
            @emitAction="emitAction"
          />
        </div>
      </div>
        <MoleculeEditionAssetContentsTreeNodeCalendar
          v-show="showChildren"
          v-for="child in nodo.children"
          :key="child.id"
          :contenido="contenido"
          :disabledDragg="disabledDragg"
          :element="element"
          :info="info"
          :is-child="true"
          :nodo="child"
          :node-actions="nodeActions"
          :node-actions-class="nodeActionsClass"
          :parent="nodo"
          @emitAction="emitAction"
          @event-data="dataChild"
        />
    </li>
  </ul>
</template>

<script>

import interactionPlugin, { Draggable } from '@fullcalendar/interaction'

export default {
  name: 'MoleculeEditionAssetContentsTreeNodeCalendar',

  props: {
    contenido: Object,

    disabledDragg: {
      type: Boolean,
      default: true
    },

    element: Object,

    info: {
      type: Object,
      default: null
    },

    isChild: Boolean,
    nodo: Object,
    nodeActions: String,
    nodeActionsClass: String,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      moleculeNodeActions: () => import(`@/components/molecules/MoleculeEditionAssetContentsTreeNode${this.nodeActions}`),
      showChildren: false
    }
  },

  mounted () {
    this.getNodo(this)
  },

  methods: {
    dataChild (child) {
      this.nodeChild = child
    },

    emitAction (params) {
      this.$emit('emitAction', params)
    },

    getChildren (nodo) {
      let array = []
      nodo.$children.forEach(child => {
        array.push(child.nodo.id)
      })
      return array
    },

    getNodo (nodo) {
      new Draggable(this.$refs.el, {
        itemSelector: '.fc-event',
        eventData: {
          title: nodo.nodo.nombre,
          id: nodo.nodo.id,
          extendedProps: {
            pather: nodo.isChild ? nodo.$parent.nodo.id : null,
            children: nodo.getChildren(nodo)
          }
        }
      })

      if (nodo.$children.length) {
        nodo.$children.forEach(child => {
          this.getNodo(child)
        })
      }
    },

    toggleChildren () {
      this.showChildren = !this.showChildren
    }
  }
}
</script>
